/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import { Link } from "react-router-dom";

const ContactComponent = () => {
  return (
    <>
      <>
        <div className="inner-page-banner">
          <div className="breadcrumb-vec-btm">
            <img
              className="img-fluid"
              src="assets/images/bg/inner-banner-btm-vec.png"
              alt=""
            />
          </div>
          <div className="container">
            <div className="row justify-content-center align-items-center text-center">
              <div className="col-lg-6 align-items-center">
                <div className="banner-content">
                  <h1>Contact Us</h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Contact Us
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="banner-img d-lg-block d-none">
                  <div className="banner-img-bg">
                    <img
                      className="img-fluid"
                      src="assets/images/bg/inner-banner-vec.png"
                      alt=""
                    />
                  </div>
                  <img
                    className="img-fluid"
                    src="assets/images/bg/inner-banner-img.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-pages pt-120 mb-120">
          <div className="container">
            <div className="row align-items-center g-lg-4 gy-5">
              <div className="col-lg-5">
                <div className="contact-left">
                  <div className="hotline mb-80">
                    <h3>Call Us Now</h3>
                    <div className="icon">
                      <img src="assets/images/icon/phone-icon4.svg" alt="" />
                    </div>
                    <div className="info">
                      <h6>
                        <a href="tel:+ 000 000 000">+ 000 000 000</a>
                      </h6>
                      <h6>
                        <a href="tel:+ 000 000 000">+ 000 000 000</a>
                      </h6>
                    </div>
                  </div>
                  <div className="location">
                    <h3>Call Us Now</h3>
                    <div className="icon">
                      <img src="assets/images/icon/location4.svg" alt="" />
                    </div>
                    <div className="info">
                      <h6>
                        <a href="#">
                          Address Pet Avengers
                          <br />
                          Pet Avengers
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="contact-form">
                  <h2>Have Any Questions</h2>
                  <form>
                    <div className="row">
                      <div className="col-lg-12 mb-40">
                        <div className="form-inner">
                          <input type="text" placeholder="Enter your name" />
                        </div>
                      </div>
                      <div className="col-lg-6 mb-40">
                        <div className="form-inner">
                          <input type="text" placeholder="Enter your email" />
                        </div>
                      </div>
                      <div className="col-lg-6 mb-40">
                        <div className="form-inner">
                          <input type="text" placeholder="Subject" />
                        </div>
                      </div>
                      <div className="col-lg-12 mb-40">
                        <div className="form-inner">
                          <textarea
                            placeholder="Your message"
                            defaultValue={""}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-inner">
                          <button className="primary-btn1">
                            Send Message <i className="bi bi-arrow-right" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default ContactComponent;
